module.exports = __webpack_public_path__ + "static/media/hotel-2.5c2e2e1d.jpg";